import { render, staticRenderFns } from "./SidebarProductPricesBlock.vue?vue&type=template&id=c00e09b0&scoped=true"
import script from "./SidebarProductPricesBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarProductPricesBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarProductPricesBlock.vue?vue&type=style&index=0&id=c00e09b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00e09b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c00e09b0')) {
      api.createRecord('c00e09b0', component.options)
    } else {
      api.reload('c00e09b0', component.options)
    }
    module.hot.accept("./SidebarProductPricesBlock.vue?vue&type=template&id=c00e09b0&scoped=true", function () {
      api.rerender('c00e09b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarProductPricesBlock.vue"
export default component.exports